import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoIcon from '@ui-components-3/icons/lib/regular/CircleInfo'
import ServiceHoursModal from './ServiceHoursModal'

type ServiceHoursInfoProps = {
  selectedDate: Date
}

const ServiceHoursInfo = ({ selectedDate }: ServiceHoursInfoProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const { t } = useTranslation()

  const toggleModal = useCallback(
    (_isVisible: boolean) => () => {
      setIsModalVisible(_isVisible)
    },
    [],
  )

  return (
    <>
      <p className="typography-body leading-4">
        {t('serviceHours.infoTitle')}
        <button
          type="button"
          className="btn-sm btn-primary-borderless ml-2 h-4 min-w-0 translate-y-1 p-0"
          onClick={toggleModal(true)}
          aria-label={t('serviceHours.openModalButtonLabel')}
        >
          <InfoIcon aria-hidden="true" />
        </button>
      </p>
      {!!isModalVisible && <ServiceHoursModal onClose={toggleModal(false)} selectedDate={selectedDate} />}
    </>
  )
}

export default ServiceHoursInfo
